import api from "../client"
import { ShippingPricePayload, ShippingPriceResponseData } from "../types/shipping-price"

export const shippingPriceRequest = async (payload: ShippingPricePayload) => {
    const { data } = await api.post<ShippingPriceResponseData>(
        `/shipping-price`,
        payload
    )

    return data
}
